export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/d9f26165e744ef064b81249371ce3c44.svg";